import React from "react";
import { BsSuitHeartFill } from "react-icons/bs";

import { FaShoppingCart } from "react-icons/fa";
import { MdOutlineLabelImportant } from "react-icons/md";
import Image from "../../designLayouts/Image";
import Badge from "./Badge";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart, addToWishlist } from "../../../redux/orebiSlice";

const Product = (props) => {
  const dispatch = useDispatch();
 
 

  
  const navigate = useNavigate();
  const productItem = props;
  const handleProductDetails = () => {
    const formattedProductName = props.productName
      .toLowerCase()
      .split(" ")
      .join("-");
    //alert("productItem"+JSON.stringify(productItem));
    navigate(`/product/${formattedProductName}`, {
      state: {
        item: productItem,
      },
    });
  };
  return (
    <div className="w-full relative group">
      <div className="max-w-80 max-h-80 relative overflow-y-hidden ">
        <div>
          <Image className="w-full h-full" imgSrc={props?.img[0] || props?.img} />
        </div>
        <div className="absolute top-6 left-8">
          {props.badge && <Badge text="New" />}
        </div>
        <div className="w-full h-32 absolute bg-white -bottom-[130px] group-hover:bottom-0 duration-700">
          <ul className="w-full h-full flex flex-col items-end justify-center gap-2 font-titleFont px-2 border-l border-r">
           
            <li
              onClick={() =>
                dispatch(
                  addToCart({
                    _id: props._id,
                    category: props.category,
                    productName: props.productName,
                    quantity: 1,
                    image: props.img,
                    badge: props.badge,
                    price: props.price,
                    colors: props.color,
                    weight: props.weight,
                    size: props.size,
                    des: props.des,
                    video: props.video,
                    wastage: props.wastage,
                    stockType: props.stockType,
                    designName: props.designName,
                    onboardDate: props.onboardDate,
                    goldRateWhileOnboard: props.goldRateWhileOnboard,
                    pgjWastage: props.pgjWastage,
                  })
                )
              }
              className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full"
            >
              Add to Cart
              <span>
                <FaShoppingCart />
              </span>
            </li>
            <li
              onClick={handleProductDetails}
              className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full"
            >
              View Details
              <span className="text-lg">
                <MdOutlineLabelImportant />
              </span>
            </li>
            <li onClick={() =>
              dispatch(
                addToWishlist({
                  _id: props._id,
                  category: props.category,
                  productName: props.productName,
                  quantity: 1,
                  image: props.img,
                  badge: props.badge,
                  price: props.price,
                  colors: props.color,
                  weight: props.weight,
                  size: props.size,
                  des: props.des,
                  video: props.video,
                  wastage: props.wastage,
                  stockType: props.stockType,
                  designName: props.designName,
                  onboardDate: props.onboardDate,
                  goldRateWhileOnboard: props.goldRateWhileOnboard,
                  pgjWastage: props.pgjWastage,
                })
              )
            }
              className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full">
              Add to Wish List
              <span>
                <BsSuitHeartFill />
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-80 py-6 flex flex-col gap-1 border-[1px] border-t-0 px-4">
        <div className="flex items-center justify-between font-titleFont">
          <h2 className="text-lg text-primeColor font-bold">
            {props?.productName}
          </h2>
          <p className="text-[#767676] text-[14px]">₹{props?.price}</p>
        </div>
        <div>
          <p className="text-[#767676] text-[14px]">{props?.color}</p>
        </div>
      </div>
    </div>
  );
};

export default Product;
